import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { GetRoleList } from '../../../../store/NTX/Security/Rules/RulesSlice';
import useLookupModule from '../../../../hooks/Lookups/use-Lookup-Module';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
// import Loader from '../../../../components/Shared/Loader/Loader';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import AddRule from './AddRule';
import Pagination from '../../../../components/Shared/Pagination/Pagination';
import UpdateRules from './UpdateRules';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import Loading from '../../../../components/Shared/Loader/Loading';
import NtxTable from '../../../../components/DataTable/NtxTable';

const Index = () => {
  const { HasPermission } = usePermissions();

  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();
  const [rulesId, setRulesId] = useState<string>();
  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [search, setSearch] = useState('');
  const [selectedValue, setSelectedValue] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(10);
  const { RulesList, loading, error } = useAppSelector((state) => state.Rules);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (RulesList?.length === 0) {
      dispatch(GetRoleList());
    }
  }, [dispatch]);

  const filteredSearch = RulesList?.slice()?.filter((item) => {
    const searchLowerCase = search.toLowerCase();
    return (
      item.name?.toLowerCase().toString().includes(searchLowerCase) ||
      item.name2?.toLowerCase().toString().includes(searchLowerCase)
    );
  });

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredSearch?.slice(indexOfFirstData, indexOfLastData);

  //!~~~

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Start Date'), key: 'Start' },
    { title: t('End_Date'), key: 'End' },
    { title: t(''), key: 'action', className: 'text-end' },
  ];

  const tableData = RulesList?.map((item) => {
    let rowClass;

    return {
      Name: i18n.language === 'en' ? item.name : item.name2,
      Start: item.startDate,
      End: item.endDate,

      action: HasPermission('NtxEditpermissionsRule') && (
        <>
          <button
            type="button"
            className="btn btn-sm btn-outline-theme me-1"
            data-bs-toggle="modal"
            data-bs-target="#modalEditRule"
            onClick={() => setRulesId(item.id)}>
            <i className="far fa-lg fa-fw me-2 fa-edit"></i>
            {t('Button.Edit')}
          </button>

          <button
            type="button"
            onClick={() =>
              Navigate(`${item.id}/PermissionRule`, {
                state: {
                  name: i18n.language === 'en' ? item.name : item.name2,
                },
              })
            }
            className="btn  btn-sm btn-outline-theme me-1">
            <i className="fas fa-lg fa-fw me-2 fa-tasks"></i>
            {t('Permissions')}
          </button>
        </>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });

  //!~~~

  const { Module } = useLookupModule();
  useEffect(() => {
    if (Module?.length) {
      setSelectedValue(Module[0].id);
    }
  }, [Module]);

  //________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },
    {
      name: 'RulesPermissions',
      link: null,
    },
  ];

  return (
    <div>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName="RulesPermissions" />

        <div className="ms-auto">
          {HasPermission('NtxAddpermissionsRule') && (
            <Link
              to=""
              className="btn btn-theme"
              data-bs-toggle="modal"
              data-bs-target="#modalAddRule">
              <i className="fa fa-plus-circle fa-fw me-1"></i>
              {t('AddUserRules')}
            </Link>
          )}
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddUserRules')} id="modalAddRule" size="lg">
        <AddRule />
      </ModalComponent>

      <ModalComponent title={t('EditUserRules')} id="modalEditRule" size="lg">
        {rulesId && <UpdateRules rulesId={rulesId} />}
      </ModalComponent>
    </div>
  );
};

export default Index;
